export default {
    MissingLicenseInfo: 4001,
    TooManyPlayersInRoom: 4002,
    TooManyRooms: 4003,
    TeacherLeft: 4004
}
